import React from "react";

interface BoardsColumnHeaderProps {
   columnRecord: any;
}

export default function BoardsColumnHeader({ columnRecord }: BoardsColumnHeaderProps) {
   const projectName = columnRecord.getData("text");
   const projectColor = columnRecord.getData("color");

   return (
      <span
         className="boards-column-header"
         style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            width: "100%",
            maxWidth: "100%",
            minHeight: "1.5rem",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Inter",
            color: "white",
            lineHeight: "1.25rem",
            letterSpacing: "0.01rem",
            boxSizing: "border-box",
            margin: 0,
            padding: "4px",
            overflow: "hidden",
            wordBreak: "normal",
            overflowWrap: "break-word",
         }}
      >
         {projectColor && (
            <span
               style={{
                  display: "inline-block",
                  width: "10px",
                  minWidth: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: projectColor,
                  flexShrink: 0,
                  marginRight: "6px",
               }}
            />
         )}
         <span
            style={{
               overflow: "hidden",
               textOverflow: "ellipsis",
               wordBreak: "normal",
               overflowWrap: "break-word",
            }}
         >
            {projectName}
         </span>
      </span>
   );
}
